import { LinkFallbackToast } from '@components'
import toast from 'react-hot-toast'
import { Trans } from 'react-i18next'

const DOWNLOAD_FALLBACK_TOAST_DURATION = 6000

const showDownloadFallbackToast = (href: string, filename: string): void => {
  toast(
    t => (
      <LinkFallbackToast
        href={href}
        downloadFilename={filename}
        onDismiss={() => toast.dismiss(t.id)}
        message={<Trans i18nKey="general.popupFallBackLink" />}
        buttonLabel={<Trans i18nKey="general.popupFallBackDownload" />}
      />
    ),
    {
      duration: DOWNLOAD_FALLBACK_TOAST_DURATION
    }
  )
}

export const saveBlobAsFile = (blob: Blob, filename: string, showBackUpToast = true): void => {
  const href = URL.createObjectURL(blob)
  const link = document.createElement('a')

  try {
    link.href = href
    link.download = filename
    link.style.display = 'none'

    if (document.body) {
      document.body.appendChild(link)
    }
    link.click()
  } finally {
    link.remove()
    showBackUpToast && showDownloadFallbackToast(href, filename)
    window.setTimeout(() => URL.revokeObjectURL(href), DOWNLOAD_FALLBACK_TOAST_DURATION + 1000)
  }
}
